import React from 'react';
import { Search } from 'lucide-react';

const SearchBar = ({ onSearch }) => {
    return (
        <div className="search-container" id="search">
            <Search className="search-icon" size={24} />
            <input
                type="text"
                className="search-input"
                placeholder="Search for your favorite dish..."
                onChange={(e) => onSearch(e.target.value)}
            />
        </div>
    );
};

export default SearchBar;
